import { type Transition, type Variants } from 'framer-motion';

import { EASE_CUBIC } from '@pkg/components/Sections/Profile/StyledThemeProvider/themes/default';

export const backdropTransition: Transition = {
    ease: 'easeInOut',
    duration: 0.4,
};

export enum InteriorVariant {
    Hidden = 'hidden',
    Show = 'show',
}

export const interiorVariants: Variants = {
    [InteriorVariant.Hidden]: {
        opacity: 0,
        transition: {
            ease: 'easeInOut',
            duration: 0.3,
        },
    },
    [InteriorVariant.Show]: {
        opacity: 1,
        transition: {
            ease: 'easeInOut',
            duration: 0.4,
            delay: 0.3,
        },
    },
};

///
/// Sheet Wrapper

export const sheetMobileHidden = {
    translateY: '100%',
};

export const sheetMobileShow = {
    translateY: '0%',
};

export const sheetDesktopHidden = {
    translateX: '100%',
    scale: 0.75,
};

export const sheetDesktopShow = {
    translateX: '0%',
    scale: 1,
};

export const sheetDesktopTuck = {
    // Since the other animation values use `%`,
    // we need to do the same. `px` will not work.
    translateX: '10%',
    scale: 1,
};

export const sheetTransition: Transition = {
    ease: EASE_CUBIC,
    duration: 0.4,
};
